import SelectDynamic from 'components/form/SelectDynamic';
import PropTypes from 'prop-types';
import ClientsRepreService from 'service/apicataleg/api/representant/ClientsRepreService';

const SelectClient = ({ onChange = () => {}, placeholder = 'CIF / raó / establiment' }) => {
  const loadOptions = async (value, callback) => {
    const options = await ClientsRepreService.queryClients(value);
    callback(options);
  };

  const getOptionLabel = (e) => {
    const { dni, rao, estab } = e;
    return estab ? `${rao} - ${estab} cif: ${dni}` : `${rao} cif: ${dni}`;
  };
  const getOptionValue = (e) => {
    const { codi } = e;
    return codi;
  };

  return (
    <SelectDynamic
      placeholder={placeholder}
      asyncLoadOptionsFunc={loadOptions}
      onSelected={onChange}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
    />
  );
};

SelectClient.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

export default SelectClient;
